module.exports = __webpack_public_path__ + "static/media/studying-at-tafe.b86e62ab.jpg";